import fuzzysort from "fuzzysort";
import emojiToolkit from "emoji-toolkit";

const EMOJI_SHORTCODES_BY_ALL_NAMES = Object.keys(emojiToolkit.emojiList).reduce((memo, emojiShortname) => {
  emojiToolkit.emojiList[emojiShortname].shortnames.forEach((altShortName) => {
    memo[altShortName] = emojiShortname;
  });
  memo[emojiShortname] = emojiShortname;
  return memo;
}, {});

const EMOJI_FUZZY_SEARCH_TARGETS = Object.keys(EMOJI_SHORTCODES_BY_ALL_NAMES).map((emojiShortcode) => fuzzysort.prepare(emojiShortcode));

const emojiFuzzyQuery = (query, callback) => {
  const fuzzySortOptions = { limit: 20, allowTypo: true, threshold: -10000 };
  const fuzzysortQueryResults = query ? fuzzysort.go(query, EMOJI_FUZZY_SEARCH_TARGETS, fuzzySortOptions) : [];
  const emojiItems = fuzzysortQueryResults.map(({ target }) => {
    const emojiDefaultName = EMOJI_SHORTCODES_BY_ALL_NAMES[target];
    return { id: target, display: emojiToolkit.shortnameToUnicode(emojiDefaultName) };
  });
  callback(emojiItems);
};

export default emojiFuzzyQuery;
